import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

export const MainSection = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 16px;
    ${media.mobileDevice`
        flex-direction:column;
        justify-content: flex-start;
        // height: 41.5rem;
        margin-top:${({ marginTop, showSingleBanner, isCondensedView }) => (marginTop ? marginTop : (!isCondensedView && showSingleBanner) ? "0px" :'14px')}; 
    `}
`;

export const ItemTable = styled.table`
    width: 100%;
    ${'' /* border-collapse: separate; */}
    border-spacing: 0;
    font-family: 'AvenirNextWorld demi';
    font-size: 14px;
    border-bottom: 1px solid #ddd;
    table-layout: fixed;
    border-collapse: collapse;
`;

export const Circle = styled.div`
    display: flex;
    align-items: center;
    width: 12px;
    height: 11px;
    border: 1px solid;
    border-radius: 50%;
    justify-content: center;
    color: #00000080;
    margin-left: 0.5%;
`;

export const TableHeader = styled.th`
    background-color: white;
    width: ${({ width }) => width && width};
    font-weight: bold;
    padding: 3px 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;

    &.quantity {
        text-align: center;
    }
    &.uom {
        padding-left: 24px;
    }
    ${media.mediumDevice`
    &.quantity {
        padding-right: 5px;
    }
`}
`;
export const TableData = styled.td`
    padding: 12px 10px;
    font-family: 'AvenirNextWorld Regular';
    font-size: 13px;
    width: ${({ width }) => width && width};
    border-bottom: ${({ borderBottom }) => borderBottom && borderBottom};

    &.quantity {
        text-align: right;
        padding-right: 10px;
    }

    &.delete {
        text-align: center;
    }

    &.description {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
    }

    &.product {
        color: #1010eb;
        font-weight: bold;
        cursor: pointer;
    }
`;

export const TableRow = styled.tr`
    &:nth-child(even) {
        background-color: #f5f5f5cc;
    }

    &:nth-child(odd) {
        background-color: white;
    }

    // &:hover {
    //   background-color: #e0e0e0;
    // }
`;
export const FilterSection = styled.div`
    width: ${({ width }) => (width ? width : '33%')};
    margin: ${({ margin }) => (margin ? margin : '0px 0px 0px 0px')};
    height: 90%;
    overflow-y: scroll;
    ${media.largeDevice`    
        width: ${({ width }) => (width ? width : '37%')};
    `}

    ${media.mediumDevice`    
        width: 45%;
    `}
    ${media.smalDevice`    
        width:${({ width }) => (width ? width : '50%')};
    `}
    ${media.mobileDevice`     
        width: 100%;
        overFlow-y:unset;
    `}
`;
export const FilterContainer = styled.div`
    height: ${(props) =>
        props.showDoubleBanner
            ? 'calc(100vh - 19.125rem)'
            : props.showSingleBanner
            ? 'calc(100vh - 16.125rem)'
            : 'calc(100vh - 11.125rem)'};
    overflow-y: scroll;
    scrollbar-width: ${({ scrollBar }) => scrollBar};
    margin-right: ${({ marginRight }) => (marginRight ? marginRight : '25px')};
    padding-bottom: 120px;
    &::-webkit-scrollbar {
        display: ${({ theme }) => theme.scrollOption.show};
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        margin-top: 15px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
        height: 7rem;
    }

    ${media.mediumDevice`
        padding-bottom: 200px;
        overflow-x:hidden;
        overflow-y: scroll;
        height: ${(props) =>
            props.showDoubleBanner
                ? 'calc(100vh - 24.125rem)'
                : props.showSingleBanner
                ? 'calc(100vh - 21.125rem)'
                : props.isCondensedView
                ? '100%'
                : 'calc(100vh - 18.125rem)'} !important;
    `}

    @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1130px) and (orientation: landscape) {
        padding-bottom: 200px;
        overflow-y: scroll;
        height: ${(props) =>
            props.showDoubleBanner
                ? 'calc(100vh - 24.125rem)'
                : props.showSingleBanner
                ? 'calc(100vh - 21.125rem)'
                : 'calc(100vh - 18.125rem)'} !important;
    }

    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        padding-bottom: 240px;
        overflow-y: scroll;
        height: ${(props) =>
            props.showDoubleBanner
                ? 'calc(100vh - 24.125rem)'
                : props.showSingleBanner
                ? 'calc(100vh - 21.125rem)'
                : 'calc(100vh - 18.125rem)'} !important;
    }

    @media screen and (min-device-width: 1070px) and (max-device-width: 1090px) and (min-device-height: 800px) and (max-device-height: 820px) and (orientation: landscape) {
        padding-bottom: 200px;
        height: ${(props) =>
            props.showDoubleBanner
                ? 'calc(100vh - 24.125rem)'
                : props.showSingleBanner
                ? 'calc(100vh - 21.125rem)'
                : 'calc(100vh - 18.125rem)'} !important;
    }

    ${media.smalDevice`
        padding-bottom: 120px;
        overflow-x:hidden;
        overflow-y: scroll;
    `}

    ${media.mobileDevice`     
        height:100%;
        width:${(props) => props.isCondensedView && '100%'};
        overflow-x:hidden;
        margin-right: 0;
        padding-bottom: 0;
    `}
`;
export const DropDownContainer = styled.div`
    display: flex;
    flex-direction: row;
    ${media.mobileDevice`
      margin-bottom:${({ marginB }) => marginB && '-10px'}; 
    `}
`;
export const ActionPanelContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: -9px;
    ${media.mobileDevice`
     background-color:${({ bgColor }) => bgColor};
       padding:${({ padding }) => (padding ? padding : '10px 0px 0px 0px')};
        flex-direction:column;
        justify-content: space-between;
    `}
    ${media.largeDevice`    
        flex-wrap:wrap;
    `}
    ${media.smalDevice`    
        flex-direction:column;
        justify-content: space-between;
    `}
`;

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: ${(props) => (props.margin ? props.margin : '10px 0px 2px 0px')};
    position: relative;
    background: #ffffff 0% 0% no-repeat padding-box;
    width: 100%;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: ${(props) =>
        props.borderRadius ? props.borderRadius : '6px'};
`;

export const SubContainerRows = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: ${(props) => props.padding};
    justify-content: space-between;
    margin-left: ${({ marginLeft }) => marginLeft};
`;
export const LineSeparator = styled.hr`
    border: 0;
    border-top: 1px solid #eee;
    box-sizing: content-box;
    height: 0;
    overflow: visible;
    margin: 0;
`;

export const Container = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    opacity: 1;
    display: flex;
    flex: column;
`;

export const ProductCategoriesContainer = styled.div`
    margin: ${(props) => (props.margin ? props.margin : '0px')};
    ${media.mobileDevice`         
    /* margin:5px 15px; */
    width:100%;
`}
`;

export const ProductButtonPanelContainer = styled.div`
    margin: 10px 10px;
    ${media.mobileDevice`              
    margin: 10px auto;
    width:95%
`}
`;

export const ItemHeader = styled.div`
    display: flex;
    letter-spacing: -0.13px;
    color: #140f4b;
    opacity: 1;
    font-family: 'Avenir Next World, Demi';
    flex-direction: row;
`;

export const ActionContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
`;
export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
`;
export const SearchButtonIcon = styled.div.attrs(({ onClick }) => ({
    onclick: onClick,
}))`
    margin-left: 16px;
    ${media.mobileDevice`              
     margin-left: 27px; 
`}
`;

export const SortButtonIcon = styled.div.attrs(({ onClick }) => ({
    onclick: onClick,
}))`
    height: 30px;
    margin-left: 20px;
    ${media.mobileDevice`     
    `}
`;

export const CardTitle = styled.div`
    font-family: 'AvenirNextWorld Demi';
    color: #140f4b;
    margin-bottom: ${(props) =>
        props.marginButtomDk ? props.marginButtomDk : ''};
    //font size
    font-size: ${(props) => (props.fontSize ? props.fontSize : '16px')};
    ${media.mobileDevice`
        margin:${(props) => (props.margin ? props.margin : '')};  
         padding:${(props) => props.padding};
         margin-left:${(props) => (props.marginLeft ? props.marginLeft : '')}; 
    `}
`;

export const ImageContainer = styled.img`
    transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : '')};
    cursor: pointer;
`;

export const SearchingItems = styled.div`
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: 300px;
    &::-webkit-scrollbar {
        display: ${({ theme }) => theme.scrollOption.show};
        width: ${({ theme }) => theme.scrollOption.width};
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
    }
    ${media.mediumDevice`
        //max-height: 660px;
        &::-webkit-scrollbar {
            display: none;
        }
    `}
    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        max-height: 280px;
    }
    ${media.smalDevice`
        //max-height: 440px;
    `}
`;
export const PanelButtonGroup = styled.div`
    display: grid;
    grid-template-columns: repeat(6, 16%);
    grid-template-rows: auto;
    column-gap: 2px;
    row-gap: 2px;
    ${media.mobileDevice`
        padding:0px;
    `}
`;

export const ProductHeader = styled.div`
    height: 62px;
    display: contents;
    ${media.mobileDevice`
background-color: ${({ backgroundColor }) => backgroundColor}
    `}
`;
export const ProductSection = styled.div`
    flex: auto;
    width: 65%;
    margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '0px 10px')};

    ${media.largeDevice`    
        width: ${({ width }) => (width ? width : '60%')};
        margin: 0 auto;
        flex:none;
    `}
    ${media.mediumDevice`    
        width: ${({ width }) => (width ? width : '50%')};
        margin: 0 auto;
        flex:none;
    `}
    ${media.smalDevice`    
        width: ${({ width }) => (width ? width : '50%')};
        margin: 0 auto;
    `}
    ${media.mobileDevice`    
        width: 100%; 
        margin: ${({ mbMargin }) => (mbMargin ? mbMargin : '32px auto 0 auto')};
        padding: ${({ mbPadding }) => (mbPadding ? mbPadding : '')};
background-color: ${({ backgroundColor }) =>
        backgroundColor ? backgroundColor : ''};
    `}
`;

export const StyledSortIcon = styled.div`
    width: 18px;
    height: 16px;
    margin: auto;
    margin-right: 8px;
    margin-top: ${(props) => props.marginTop};
    ${media.mobileDevice`    
      display:none; 
    `}
`;
export const CartMainContainer = styled.div`
    margin-top: 18px;
    height: ${({ cartHeight }) =>
        cartHeight ? cartHeight : 'calc(100vh - 24.125rem)'};
    overflow-y: scroll;
    padding-bottom: '2px';
    ${scrollBarStyle}
    padding: ${({ padding }) => (padding ? padding : '')};
    ${'' /* background-color: white; */}
    background-color: ${({ backgroundColor }) =>
        backgroundColor ? backgroundColor : ''};

    ${media.largeDevice`
        height: ${({ lgCartHeight }) =>
            lgCartHeight ? lgCartHeight : 'calc(100vh - 22.325rem)'};
    `}
    ${media.mediumDevice`
        margin-top:10px;
        height: ${({ mdCartHeight }) =>
            mdCartHeight ? mdCartHeight : 'calc(100vh - 31.525rem)'};
    `}
    ${media.smalDevice`
        margin-top: 8px;
        height: ${({ smCartHeight }) =>
            smCartHeight ? smCartHeight : 'calc(100vh - 31.525rem)'}; 
    `}
    ${media.mobileDevice`
        height: auto;
        margin-bottom: ${(props) => props.marginBottom};
    `}
    @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1130px) and (orientation: landscape) {
        height: ${({ landscapeLgCartHeight }) =>
            landscapeLgCartHeight
                ? landscapeLgCartHeight
                : ' calc(100vh - 22.13rem)'};
    }

    @media only screen and (min-device-width: 768px) and (max-device-width: 1100px) and (orientation: landscape) {
        padding-bottom: 120px;
        height: ${({ lgCartHeight }) =>
            lgCartHeight ? lgCartHeight : 'calc(100vh - 25.325rem)'};
        &::-webkit-scrollbar {
            display: none;
        }
    }

    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        padding-bottom: 120px;
        height: ${({ lgCartHeight }) =>
            lgCartHeight ? lgCartHeight : 'calc(100vh - 24.7rem)'};
    }
`;
export const CartContainer = styled.div`
    grid-template-columns: 48.5% 48.5%;
    column-gap: 15px;
    row-gap: 15px;
    display: grid;
    overflow-x: hidden;
    ${media.smalDevice`
        grid-template-columns: 100%;
    `}
    ${media.mediumDevice`
        grid-template-columns: 100%;
    `}
    @media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation : landscape) {
        grid-template-columns: 100%;
        &::-webkit-scrollbar {
            display: none;
        }
    }
`;
export const FilterStyle = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: ${({ Width }) => (Width ? '' : '100%')};
`;
export const FilterLable = styled.div`
    display: flex;
    flex-direction: row;
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
`;
export const FilterCount = styled.div`
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`
        flex-direction: ${({ displayDirection }) =>
            displayDirection ? displayDirection : 'row'};
    `}
`;
export const ActionMainContainer = styled.div`
    background-color: #f5f5f5;
    padding: ${({ padding }) => (padding ? padding : '')};
`;
export const ExpandAllProductGuide = styled.div`
    display: flex;
    align-items: center;
`;
export const ClearFilterButton = styled.div`
    display: flex;
    width: 100%;
    flex-direction: ${({ displayDirection }) => displayDirection};
    flex-wrap: wrap;
    white-space: nowrap;
    justify-content: ${({ justifyContent }) =>
        justifyContent ? 'flex-end' : 'flex-start'};
    // margin-left: 615px;
    padding-right: ${({ paddingRight }) =>
        paddingRight ? paddingRight : '18px'};
    padding-left: 18px;
    /* 
    margin-left:${({ marginLeft }) => (marginLeft ? marginLeft : 'none')}; */
    position: ${({ position }) => (position ? position : 'none')};
    left: 441px ${media.mediumDevice`
    padding-right: 12px;
    `} ${media.smalDevice`
        padding-right: 5px;
    `} ${media.mobileDevice`
        padding-right: 10px;
        padding-left: 0px;
        width: ${({ mbWidth }) => (mbWidth ? mbWidth : '100%')}
    `};
`;
export const FiltersContainer = styled.div`
    ${media.mobileDevice`
             width: 250px;
        display: flex
;
        flex-direction: row;

    `}
`;
export const ManageFilter = styled.div`
    display: flex;
    flex-direction: ${({ displayDirection }) =>
        displayDirection ? displayDirection : 'row'};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '5px'};
    flex: ${({ flexNumber }) => (flexNumber ? flexNumber : '')};
    justify-content: flex-start;
    align-items: baseline;
    ${media.mobileDevice`
        margin-bottom: ${({ mbMarginBottom }) =>
            mbMarginBottom ? mbMarginBottom : '5px'};
        justify-content: space-between;
        background-color: ${({ mbBackgroundColor }) =>
            mbBackgroundColor ? mbBackgroundColor : ''};
    `}
    width: ${({ Width }) => (Width ? 'max-content' : '')};
`;
export const ClearButtonLink = styled.div`
    color: #1010eb;
    font-size: 14px;
    //font
    font-family: 'AvenirNextWorld Demi';
    letter-spacing: -0.11px;
    width: auto;
    padding: 5px;
    height: 24px;
    cursor: pointer;
`;
export const Regular = styled.div`
    color: #140f4b;
    font-size: 14px;
    //font
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`
       margin-left:${(props) => (props.marginLeft ? props.marginLeft : '')};
 display:${(props) => (props.display ? props.display : '')}; 
;
    flex-direction: ${(props) =>
        props.displayDirection ? props.displayDirection : ''}; 
    `}
    width:${(props) => (props.width ? props.width : '')}; ;
`;
export const FiltersList = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: ${({ setmargin }) => (setmargin ? setmargin : '-2px 0px 10px 5px')};
    align-items: center;
    ${media.mobileDevice`
        /* flex-direction:column; */
        margin:-2px 0px 21px 5px;
        /* display:-webkit-inline-box; */

    `}
`;
export const DropDownStyle = styled.div`
    display: flex;
    height: 40px;
    width: ${({ width }) => (width ? width : '100%')};
    ${media.largeDevice`
         /* margin: 10px 0px 0 0;
         width:100%; */
    `}
    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {
        height: 40px;
        width: 43%;
    }
    ${media.mediumDevice`
          margin: 10px 0px 0 0;
         width:100%; 
    `}
    ${media.smalDevice`
        margin: 12px 0px 0 0;
    `}
    ${media.mobileDevice`
        margin:${(props) => (props.margin ? props.margin : '10px 0px')}; 
         width:${(props) => (props.setWidth ? props.setWidth : '100%')};
    `}
    .p-dropdown-label {
        color: #140f4b;
        font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : '900')};
        @media only screen and (min-device-width: 768px) and (max-device-width: 1300px) and (orientation: landscape) {
            font-size: 15px !important;
        }
    }
`;

export const CartActionItems = styled.div`
    font-family: 'AvenirNextWorld Bold';
    color: #140f4b;
    opacity: 1;
    display: flex;
    flex-direction: row;
    // height: ${({ height }) => (height ? height : '20px')};
    width: ${({ width }) => (width ? width : '20%')};
    font-size: 13px;
    margin: ${({ margin }) => (margin ? margin : '20px')};
    // margin-top: ${({ marginTop }) => (marginTop ? marginTop : '0px')};
    cursor: ${({ setCursor }) => (setCursor ? setCursor : null)};
    ${media.mobileDevice`
    font-family: 'AvenirNextWorld Demi';
    color: #202124;
    font-size: 20px;
     margin: ${({ margin }) => (margin ? margin : '20px')};
    // margin-right: ${({ marginRight }) => (marginRight ? marginRight : null)};
     
    
        
        
    `}
`;
export const AddIcon = styled.div`
    // display: ${({ display }) => (display ? display : 'contents')};
    // padding: ${({ padding }) => (padding ? padding : '0px 5px 2px')};
    display: ${({ isReviewSubmitScreen, display }) =>
        isReviewSubmitScreen ? null : display ? display : 'contents'};
    padding: ${({ isReviewSubmitScreen, padding }) =>
        isReviewSubmitScreen ? null : padding ? padding : '0px 5px 2px'};
`;
export const Text = styled.div`
    width: ${({ width }) => (width ? width : '83px')};
    height: ${({ height }) => (height ? height : '20px')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Demi'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '11px')};
    font-weight: 600;
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '0px')};
    color: ${({ color }) => (color ? color : '')};
    white-space: nowrap;
`;

export const PaginationContainer = styled.div`
    margin-top: 12px;
    height: 48px;
    background: #f6f6f6 0% 0% no-repeat padding-box;
    box-shadow: 0px -3px 6px #00000014;
    border-radius: 4px 4px 0px 0px;
    opacity: 1;
    width: ${({ width }) => (width ? width : ' 48.5%')};
    ${media.mobileDevice`
        flex-direction:column;
        margin: 10px 0px 0px 0px;
        box-shadow: none;
        border-radius: none;        
    `}
    ${media.smalDevice`                    
        height: auto;
        box-shadow: none;
        border-radius: none;    
    `}
    ${media.mediumDevice`    
        height: auto;
        box-shadow: none;
        border-radius: none;
        font-size: 13px;  
    `}
`;

export const MobileView = styled.div`
    display: none;
    ${media.mobileDevice`
        display: block;
    `}
`;

export const DesktopView = styled.div`
    display: block;
    ${media.mediumDevice`
        width: 51%;
    `}
    ${media.smalDevice`
        width: 51%;
    `}
    
    @media only screen and (min-device-width: 768px) {
        // position: fixed;
        bottom: 0;
        width: 100%;
    }

    ${media.mobileDevice`
        display: none;
    `}

    .product-guid-custom-pagination {
        position: fixed;
        width: ${({ width }) => (width ? width : '48.5%')};
        max-width: ${({ maxWidth }) => maxWidth && maxWidth};
        bottom: 0;
        background-color: white;
        padding-top: ${({ paddingTop }) => paddingTop && paddingTop};

        ${media.mobileDevice`
            position: relative;
            width: 100%;
            bottom: 0;
        `}
        @media only screen and (min-device-width: 1024px) and (max-device-width: 1026px) {
            width: ${({ isCondensedView }) => isCondensedView && '60%'};
        }
        @media only screen and (min-device-width: 768px) and (max-device-width: 770px) {
            width: ${({ isCondensedView }) => isCondensedView && '65.5%'};
        }
        @media only screen and (min-device-width: 820px) and (max-device-width: 830px) {
            width: ${({ isCondensedView }) => isCondensedView && '65.5%'};
        }
        #paginationInfo {
            @media only screen and (min-device-width: 768px) and (max-device-width: 1300px) and (orientation: landscape) {
                font-size: 13px !important;
            }
        }
    }
`;

export const PaginationContainerMobile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
    width: 90%;
    ${media.mobileDevice`
        flex-direction:column;
        margin: 10px 0px 0px 0px;
        justify-content: space-between;
        position: sticky;
        bottom:0;
    `}
`;

export const SearchBoldStyle = styled.div`
    width: 30px;
    height: 30px;
    border: 1px solid #1021eb;
    border-radius: 5px;
    padding: 4px;
    margin: 3px;
    box-shadow: 0px 0px 2px #00000029;
`;

export const SearchStyle = styled.div`
    width: 30px;
    height: 30px;
    border: 1px solid #0000001a;
    border-radius: 5px;
    padding: 4px;
    margin: 3px;
    box-shadow: 0px 0px 2px #a09d9d;
`;
